import React from 'react';  
  
function Header() {  
        return ( 
<React.Fragment> 
<header id="header" class="fixed-top">
            <div class="container d-flex align-items-center">

      <h1 class="logo me-auto"><a href="/">Mentor</a></h1>
      

      <nav id="navbar" class="navbar order-last order-lg-0">
        <ul>
          <li><a class="active" href="/">Home</a></li>
          <li><a href="/about">About</a></li>
          <li><a href="courses.html">Courses</a></li>
          <li><a href="trainers.html">Trainers</a></li>
          <li><a href="events.html">Events</a></li>
          <li><a href="pricing.html">Pricing</a></li>
          <li><a href="/contact">Contact</a></li>
        </ul>
        <i class="bi bi-list mobile-nav-toggle"></i>
      </nav>

      <a href="courses.html" class="get-started-btn">Get Started</a>

    </div>
    </header>
    </React.Fragment> 
        )  
}  
  
export default Header  